import { render, staticRenderFns } from "./lgsearch.vue?vue&type=template&id=152ba55c&"
import script from "./lgsearch.vue?vue&type=script&lang=js&"
export * from "./lgsearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/kccp/PROD/kccp-portal-web-internet-dynamic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('152ba55c', component.options)
    } else {
      api.reload('152ba55c', component.options)
    }
    module.hot.accept("./lgsearch.vue?vue&type=template&id=152ba55c&", function () {
      api.rerender('152ba55c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/nhso/lgsearch.vue"
export default component.exports